import React, { useEffect, useState } from 'react';
import { supabase } from './supabase';
import Login from './components/Login';
import Home from './components/Home';
import Dashboard from './components/Dashboard';

function App() {
  const [session, setSession] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [currentBoard, setCurrentBoard] = useState<any>(null);
  const [currentWorkspace, setCurrentWorkspace] = useState<any>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) { setCurrentBoard(null); setCurrentWorkspace(null); }
    });
    return () => subscription.unsubscribe();
  }, []);

  // Restaura board da URL ao carregar
  useEffect(() => {
    if (!session) return;
    const params = new URLSearchParams(window.location.search);
    const boardId = params.get('board');
    if (!boardId) return;

    const restore = async () => {
      const { data: board } = await supabase.from('boards').select('*').eq('id', boardId).single();
      if (!board) return;
      const { data: workspace } = await supabase.from('workspaces').select('*').eq('id', board.workspace_id).single();
      if (board && workspace) {
        setCurrentBoard(board);
        setCurrentWorkspace(workspace);
      }
    };
    restore();
  }, [session]); // eslint-disable-line

  const navigateToBoard = (board: any, workspace: any) => {
    setCurrentBoard(board);
    setCurrentWorkspace(workspace);
    window.history.pushState({}, '', `?board=${board.id}`);
  };

  const navigateHome = () => {
    setCurrentBoard(null);
    setCurrentWorkspace(null);
    window.history.pushState({}, '', window.location.pathname);
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f12', color: '#fff', fontFamily: 'sans-serif' }}>
      Carregando...
    </div>
  );

  if (!session) return <Login />;

  if (currentBoard) return (
    <Dashboard
      session={session}
      board={currentBoard}
      workspace={currentWorkspace}
      onBack={navigateHome}
    />
  );

  return (
    <Home
      session={session}
      onSelectBoard={navigateToBoard}
    />
  );
}

export default App;